import React from "react";

import {
    BulletPointHeaderText,
    BulletPoints,
    PrimaryPriceText,
    SecondaryPriceText,
    PriceLayout,
    HeaderAndPriceLayout,
    CardLayout,
    HeaderLayout,
    BulletPoint
} from "core/SubscriptionUpsellCard";
import Badge from "core/Badge";

const FreeUserUpsell = () => (
    <CardLayout>
        <HeaderAndPriceLayout>
            <HeaderLayout>
                <BulletPointHeaderText>
                    Free with Creative Pro
                </BulletPointHeaderText>
                <Badge badgeStyle="muted">Beta</Badge>
            </HeaderLayout>
            <PriceLayout>
                <PrimaryPriceText>$9.99/mo</PrimaryPriceText>
                <SecondaryPriceText>paid yearly</SecondaryPriceText>
            </PriceLayout>
        </HeaderAndPriceLayout>
        <BulletPoints>
            <BulletPoint>Unlimited icons & icon sets</BulletPoint>
            <BulletPoint>Unlimited Standard photos</BulletPoint>
            <BulletPoint>Royalty-free, attribution-free</BulletPoint>
            <BulletPoint>Unlock editing, apps, & more</BulletPoint>
        </BulletPoints>
    </CardLayout>
);

export default FreeUserUpsell;
